<template>
  <fin-data-loader :resolver="loadData">

    <!-- User Long -->
    <template v-if="!adminArea" #content>
      <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                   v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                   class="mx-0 mt-3"
                   fill-height
                   fluid>
        <v-row>
          <v-col v-if="showList" cols="12" lg="4" md="5" sm="6">

            <v-card>
              <v-img :height="$vuetify.breakpoint.xs ? '80px' : '150px'"
                     :src="require('@/assets/finCommunity/new-post.svg')"
                     dark
              >
                <h1
                  :style="{position: 'absolute', bottom: '10px', textAlign: 'center', width: '100%', color: $finColors.primaryDark}">
                  Meine Nachrichten</h1>
              </v-img>

              <fin-speaker-messages :adjust-max-height="$vuetify.breakpoint.xs ? 178 : 248"
                                    :messages="speakerMessages"
                                    hide-text-preview
                                    max-width="100%"
                                    @speakerMsgClicked="msg => selectMessage(msg)">
                <template #actions>
                  <div class="pr-6 pb-3" style="text-align: right;">
                    <v-btn :disabled="!nextToken || loadingUserData"
                           @click="loadUserData">
                      <v-icon :class="`${loadingUserData ? 'mdi-spin': ''}`">icon-refresh</v-icon>
                      mehr
                    </v-btn>
                  </div>
                </template>
              </fin-speaker-messages>
            </v-card>
          </v-col>

          <v-col v-if="speakerMessages && speakerMessages.length > 0 && selectedRow.id" cols="12" lg="8" md="7" sm="6">
            <fin-speaker-message v-if="$vuetify.breakpoint.xs ? !showList : true"
                                 :message="selectedRow.message"
                                 style="max-width: 600px;"
                                 @input="messageBackClicked"/>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <!-- Admin Long -->
    <template v-else-if="adminArea && !speakerShort" #content>
      <fin-content-section v-if="!$route.params.id && !$route.meta.newPage"
                           v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                           v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                           class="pt-9 pb-9"
                           container-class="speaker-container"
                           content-class="speaker-content"
                           title="Meine Nachrichten">
        <v-container class="mx-0"
                     fill-height
                     fluid>
          <v-row :no-gutters="$vuetify.breakpoint.xs">
            <v-col v-if="showList" :md="9" :sm="speakerShort ? 12 : 6" cols="12">
              <v-data-table
                :headers="headersAdmin"
                :items="speakerMessages"
                :items-per-page="itemsPerPage"
                :sort-by="sortedBy"
                sort-desc
                class="elevation-1"
                dense
                no-data-text="Du hast noch keine Nachrichten erhalten ..."
                @click:row="(item) => rowClicked(item)"
              >

                <template #item.type="{ item }">
                  <v-tooltip right>
                    <template #activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ messageIcon(item.type) }}
                      </v-icon>
                    </template>
                    <span>{{ item.type }}</span>
                  </v-tooltip>
                </template>

                <template #item.title="{ item }">
                  {{ item.title }}
                </template>

                <template #item.approved="{ item }">
                  <v-icon :color="item.approved ? $finColors.accentGreen : $finColors.paleRed"
                          @click="(item.approved === false) ? showApprovedDialog(item.id, item.title, !item.approved) : ''">
                    {{ approvedIcon(item.approved) }}
                  </v-icon>
                </template>

                <template #item.createdAt="{ item }" style="text-align: center">
                  {{ item.createdAt | dayAndMonthAndYearNumericAndHour }}
                </template>

                <template #footer.prepend>
                  <v-btn @click="loadAdminData">Weitere Nachrichten laden</v-btn>
                </template>

                <template v-if="adminArea" #item.edit="{ item }">
                  <v-icon v-if="!item.approved" @click="goTo(item.id)">icon-edit</v-icon>
                </template>
              </v-data-table>
            </v-col>

            <v-col v-if="speakerMessages.length > 0" cols="12" :md="3" sm="6">
              <fin-speaker-message v-if="$vuetify.breakpoint.xs ? !showList : true"
                                   :message="selectedRow"
                                   @input="showList = true"/>
              <v-btn v-if="adminArea" :to="{name: 'finSpeakerCreateMessage'}" absolute bottom dark fab right
                     style="bottom: 10px;">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>

        </v-container>

        <fin-dialog v-if="showDialog" :value=showDialog :max-width="550" hideCloseButton>
          <template #title>
            Nachricht veröffentlichen
          </template>
          <template>
            <p>Soll der Status der Nachricht <b>{{ title }}</b> von</p>
            <v-icon :color="!tempStatus ? $finColors.accentGreen : $finColors.paleRed">{{ approvedIcon(!tempStatus) }}
            </v-icon>
            zu
            <v-icon :color="tempStatus ? $finColors.accentGreen : $finColors.paleRed">{{ approvedIcon(tempStatus) }}
            </v-icon>
            geändert werden und die Nachricht somit veröffentlicht werden? Du kannst diese dann nicht mehr bearbeiten!
          </template>
          <template #actions>
            <v-btn class="mx-2 px-2" dark @click="changeApprovedStatus(tempId, tempStatus)">Ja</v-btn>
            <v-btn class="mx-2 px-2" dark @click="closeApprovedDialog">Nein</v-btn>
          </template>
        </fin-dialog>

      </fin-content-section>
    </template>

    <!-- Admin Short -->
    <template v-else-if="adminArea" #content>
      <v-container class="mx-0 px-7"
                   fill-height
                   fluid
                   style="max-width: 1000px;">
        <v-row :no-gutters="$vuetify.breakpoint.xs">
          <v-col v-if="showList" :sm="speakerShort ? 12 : 6" cols="12">
            <v-data-table
              :headers="headersAdminShort"
              :hide-default-footer="true"
              :hide-default-header="true"
              :items="speakerMessages"
              :items-per-page="itemsPerPage"
              :sort-by="sortedBy"
              dense
              no-data-text="Du hast noch keine Nachrichten erhalten ..."
              sort-desc
              @click:row="(item) => goTo(item.id, item.approved)"
            >
              <template #item.type="{ item }">
                <v-tooltip right>
                  <template #activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ messageIcon(item.type) }}
                    </v-icon>
                  </template>
                  <span>{{ item.type }}</span>
                </v-tooltip>
              </template>

              <template #item.title="{ item }">
                {{ item.title }}
              </template>

              <template #item.createdAt="{ item }">
                {{ item.createdAt | dayAndMonthAndYearNumericAndHour }}
              </template>

              <template v-if="adminArea" #item.edit="{ item }">
                <v-icon v-if="!item.approved" @click="goTo(item.id, item.approved)">icon-edit</v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </fin-data-loader>
</template>

<script>
import {mapGetters} from 'vuex'
import FinContentSection from '@/components/pages/ContentSection'
import {finSpeakerAPI} from '@/js/finAPI'
import FinSpeakerMessage from '@/components/common/speaker/message/index'
import SpeakerTools from '@/js/finSpeaker'
import FinDataLoader from "@/components/common/DataLoader"
import router from "@/router/index"
import {API, graphqlOperation} from '@/plugins/finAmplifyModules'
import {updateSpeakerMessageApproved} from "@/js/finMutations"
import SubscriptionHandler from "@/mixins/SubscriptionHandler"
import {speakerMessageSubscription} from "@/js/finSubscriptions"
import FinSpeakerMessages from "@/components/common/speaker/messages"

export default {
  name: 'fin-speaker',
  mixins: [SubscriptionHandler],
  components: {FinSpeakerMessages, FinDataLoader, FinSpeakerMessage, FinContentSection},
  props: {
    msgId: null,
    speakerShort: {
      type: Boolean,
      default: false
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    sortedBy: {
      type: String
    }
  },
  data() {
    return {
      speakerMessages: [],
      headersAdmin: [
        {text: 'Typ', value: 'type'},
        {text: 'Titel', value: 'title', width: '50%'},
        {text: 'Erstellt am', value: 'createdAt', width: '30%'},
        {value: 'edit', sortable: false},
        {text: 'Freigegeben', value: 'approved', align: 'center'}
      ],
      headersAdminShort: [
        {text: 'Typ', value: 'type'},
        {text: 'Titel', value: 'title', width: '50%'},
        {text: 'Erstellt am', value: 'createdAt', width: '30%'},
        {value: 'edit', sortable: false},
      ],
      headers: [
        {text: 'Typ', value: 'type'},
        {text: 'Titel', value: 'title'},
        {text: 'Erstellt am', value: 'createdAt'},
      ],
      selectedRow: {},
      showList: true,

      adminArea: this.$route.path.includes('admin'),
      showDialog: false,
      tempId: ' ',
      tempStatus: null,
      title: ' ',
      nextToken: undefined,
      loadingUserData: false
    }
  },
  computed: {
    ...mapGetters('auth', ['userId']),
  },
  methods: {
    handleSubscription(newData, user) {
      const {id, createdAt, readAt, status, message} = newData.data.onSpeakerMessageRecipient

      // if readAt is not set at subscription event === new message => add to top of list
      if (status === 'UNREAD') {
        this.speakerMessages.unshift({id, createdAt, readAt, status, message})
      }
      // the user has opened a message unread -> read => replace the message data
      else {
        const oldMsg = this.speakerMessages.find(m => m.id === id)

        if (oldMsg) {
          oldMsg.createdAt = createdAt
          oldMsg.readAt = readAt
          oldMsg.status = status
          oldMsg.message = message

          this.speakerMessages = [...this.speakerMessages]
        }
      }
    },
    async loadData() {
      if (this.adminArea) {
        await this.loadAdminData()
        // TODO real time changes
      } else {
        await this.loadUserData()

        this.subscribeToChanges(
          {id: this.userId},
          speakerMessageSubscription,
          (user) => {
            return {owner: user.id}
          },
          this.handleSubscription
        )

        // this check must be called after subscribeToChanges because rowClicked calls updateReadAt -> which triggers a subscription
        if (this.msgId) {
          const msg = this.speakerMessages.find(msg => msg.id === this.msgId)

          if (msg) {
            await this.rowClicked(msg)
          }
        }
      }
    },
    async loadUserData() {
      try {
        this.loadingUserData = true
        const result = await finSpeakerAPI.getUserMessages(10, this.nextToken, this.userId)
        this.speakerMessages = [...this.speakerMessages, ...result.items.filter(item => item != null)]
        this.nextToken = result.nextToken
      } catch (e) {
        console.error('finSpeaker: unable to read all messages for user', e)
      } finally {
        this.loadingUserData = false
      }
    },
    async loadAdminData() {
        try {
          const result = await finSpeakerAPI.getAdminMessages(100, this.nextToken)

          this.speakerMessages = [...this.speakerMessages, ...result.items]
          this.nextToken = result.nextToken
        } catch (e) {
          console.error('finSpeaker: unable to read all messages for admins', e)
          this.nextToken = null
        }

      if (this.msgId != null) {
        this.selectedRow = this.speakerMessages.find(msg => msg.id === this.msgId)
      }
    },

    messageIcon: SpeakerTools.messageIcon,

    approvedIcon(approved) {
      return approved ? 'icon-notification-success' : 'icon-notification-error'
    },

    async rowClicked(msg) {
      this.selectedRow = msg

      // only set readAt for user, not admin
      // the readAt is also set when clicking the TopNavigation -> see watch.msgId
      if (!this.$route.fullPath.includes('/admin') && this.selectedRow.status === 'UNREAD') {
        try {
          await finSpeakerAPI.updateReadAt(msg)
        } catch (error) {
          console.error("finSpeaker: error updating readAt status", error)
        }
      }

      if (this.$vuetify.breakpoint.xs) {
        // hide message list on xs to show only details
        this.showList = false
      }
    },

    goTo(id, approved) {
      if (!approved) {
        router.push({name: 'finSpeakerCreateMessage', params: {id: id}})
      }
    },

    showApprovedDialog(id, title, status) {
      this.tempId = id
      this.title = title
      this.tempStatus = status
      this.showDialog = true
    },

    closeApprovedDialog() {
      this.showDialog = false
    },

    changeApprovedStatus(id, approved) {
      API.graphql(graphqlOperation(updateSpeakerMessageApproved, {
        id: id, approved: approved, status: 'RELEASED'
      }))
        .then(data => {
          const msg = data.data.gr_updateSpeakerMessage
          const i = this.speakerMessages.findIndex(s => s.id === msg.id)
          this.speakerMessages[i].approved = msg.approved
          this.closeApprovedDialog()
          if (approved === true) {
            this.$toasted.global.finToast({
              message: 'Die Nachricht wurde freigegeben!',
              type: 'success'
            })
          } else {
            this.$toasted.global.finToast({
              message: 'Die Nachricht ist nicht mehr freigegeben!',
              type: 'success'
            })
          }
        })
        .catch(e => {
          console.log(e)
          if (approved === true) {
            this.$toasted.global.finToast({
              message: 'Die Nachricht konnte nicht freigegeben werden!',
              type: 'error'
            })
            this.showDialog = false
          } else {
            this.$toasted.global.finToast({
              message: 'Die Nachricht konnte nicht zurückgenommen werden!',
              type: 'error'
            })
            this.showDialog = false
          }
        })
    },
    selectMessage(msg) {
      this.rowClicked(msg)
    },
    messageBackClicked() {
      this.showList = true
      this.selectedRow = {}
    }
  },
  watch: {
    msgId(val) {
      if (this.speakerMessages && this.speakerMessages.length > 0) {
        const msg = this.speakerMessages.find(msg => msg.id === val)

        if (msg) {
          this.rowClicked(msg)
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__wrapper table thead th:first-child {
    width: 75px;
  }

  .v-data-table__wrapper table thead th,
  .v-data-table__wrapper table tr td {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .v-data-table__wrapper table tbody tr {
    cursor: pointer;
  }

  .v-data-table__mobile-row {
    min-height: 30px !important;
  }

  .v-data-table__mobile-row__header,
  .v-data-table__mobile-row__cell {
    align-self: start;
  }

  .v-data-table__mobile-row:last-child {
    padding-bottom: 10px;
  }

  .speaker-container,
  .speaker-content {
    min-height: 100% !important;
  }
}

.unread {
  font-weight: bold;
}
</style>
